import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import { F0Dialog } from '@factorialco/f0-react'

interface AddRoleModalProps {
  onClose: () => void
  onSubmit: () => void
  disableSubmitButton: () => boolean
  disabledEmployeeIds: string[]
  onSelectEmployees: (state: EmployeeSelectorV2MultiSelectState) => void
  buttonCentered?: boolean
}

const AddRoleModal = ({
  onClose,
  onSubmit,
  disableSubmitButton,
  disabledEmployeeIds,
  onSelectEmployees,
  buttonCentered,
}: AddRoleModalProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const onCloseModal = () => {
    setOpenModal(false)
    onClose()
  }

  const onSubmitModal = () => {
    onSubmit()
    setOpenModal(false)
  }

  return (
    <>
      <Box paddingTop="s24" alignItems={buttonCentered ? 'center' : 'baseline'}>
        <Button iconName="add" type={'secondary'} onClick={() => setOpenModal(true)}>
          {i18n.t('common.add')}
        </Button>
      </Box>
      <F0Dialog
        title={i18n.t('project_management.settings.sections.project_roles.modal.title')}
        onClose={onCloseModal}
        onSubmit={onSubmitModal}
        isOpen={openModal}
        disableFocusTrap
        width="sm"
        primaryAction={{
          label: i18n.t('common.add'),
          onClick: onSubmitModal,
          disabled: disableSubmitButton(),
        }}
        secondaryActions={[
          {
            label: i18n.t('common.cancel'),
            onClick: onCloseModal,
          },
        ]}
      >
        <Box padding="s16">
          <EmployeeSelectorV2
            multiple
            forcedFilters={{ excludeCurrentEmployee: true, excludeIds: disabledEmployeeIds }}
            options={{ asList: true }}
            onChange={onSelectEmployees}
          />
        </Box>
      </F0Dialog>
    </>
  )
}

export default AddRoleModal
